import React from 'react';

export const listaContactos = () => {
	return [
		{
			nombreContacto: 'Bo Bichette',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '12:23',
		},
		{
			nombreContacto: 'Frank Thomas',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '12:67',
		},
		{
			nombreContacto: 'Roberto Hermoso',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '21:13',
		},
		{
			nombreContacto: 'Felipe Augusto',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '15:54',
		},
		{
			nombreContacto: 'Sofia Hernandez',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '11:23',
		},
		{
			nombreContacto: 'Pablo Preciado',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '17:27',
		},
		{
			nombreContacto: 'Angel Barrera',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '04:23',
		},
		{
			nombreContacto: 'Pepe Nuñez',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '04:23',
		},
		{
			nombreContacto: 'Montaña Julia',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '08:34',
		},
		{
			nombreContacto: 'Angel Barrera',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '04:23',
		},
		{
			nombreContacto: 'Pepe Nuñez',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '04:23',
		},
		{
			nombreContacto: 'Montaña Julia',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '08:34',
		},
		{
			nombreContacto: 'Angel Barrera',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '04:23',
		},
		{
			nombreContacto: 'Pepe Nuñez',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '04:23',
		},
		{
			nombreContacto: 'Montaña Julia',
			imagenContacto:
				'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.cJwC51YhZRRSndTONMPxQAHaHa%26pid%3DApi&f=1',
			horaUltimoMensaje: '08:34',
		},
	];
};
